var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4166 43.75V39.5833C35.4166 37.3732 34.5387 35.2536 32.9759 33.6908C31.4131 32.128 29.2934 31.25 27.0833 31.25H10.4166C8.20651 31.25 6.08689 32.128 4.52409 33.6908C2.96129 35.2536 2.08331 37.3732 2.08331 39.5833V43.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 22.9167C23.3524 22.9167 27.0834 19.1857 27.0834 14.5833C27.0834 9.98096 23.3524 6.25 18.75 6.25C14.1476 6.25 10.4167 9.98096 10.4167 14.5833C10.4167 19.1857 14.1476 22.9167 18.75 22.9167Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9167 43.75V39.5833C47.9153 37.7369 47.3008 35.9433 46.1695 34.484C45.0383 33.0247 43.4545 31.9824 41.6667 31.5208",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 6.52081C35.1258 6.97977 36.7146 8.02227 37.8492 9.48396C38.9838 10.9456 39.5996 12.7434 39.5996 14.5937C39.5996 16.4441 38.9838 18.2418 37.8492 19.7035C36.7146 21.1652 35.1258 22.2077 33.3333 22.6666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenants);
export default __webpack_public_path__ + "static/media/Tenants.737264cd55c920fd5db817b94bcce5b8.svg";
export { ForwardRef as ReactComponent };